import {
  breakpoints,
  customScrollMinimal,
  Modal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ${Modal.Styled.ModalContainer} {
    width: 800px;
  }

  @media ${breakpoints['max-sm']} {
    ${Modal.Styled.ModalContainer} {
      width: 80%;
    }
  }
`;

export const Content = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const Sources = styled.div`
  max-height: 30vh;
  overflow-y: auto;
  ${customScrollMinimal};
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${breakpoints['max-sm']} {
    max-height: 20vh;
  }
`;

export const ResetDescription = styled.p`
  ${typographyV2.bodySm};
`;
